// initial state
import * as base from './base.js'
const baseName = '/admin/api/realData'

const obj = base.setBaseUrl('realData', baseName)
const a = Object.assign(obj)
export default a
